/**
 * The version of the Terms a user is consenting to.
 *
 * ONE definition, shared by the client that asks and the server that records.
 * Two copies would let the recorded version drift from the document actually
 * shown — which is the only fact the record exists to establish.
 *
 * 🔴 BUMP THIS WHENEVER THE TERMS CHANGE MATERIALLY. Consent is to a specific
 * document: if the text changes and the version does not, every stored row
 * silently starts asserting that users agreed to wording they never saw.
 */
export const TERMS_VERSION = "2026-08-10";

/** Where the document itself lives, so a record can be checked against it. */
export const TERMS_URL = "https://fahaliai.com/terms";
